export default __webpack_public_path__ + "img/music.7ec33d79.svg";